<div class="bg-page flex min-h-screen flex-col">
  <header class="shrink-0 px-8 py-5">
    <a href="/">
      <img alt="Galia" class="h-8 dark:hidden" src="/atoptima_color_v2.png" />
      <img alt="Galia" class="hidden h-8 dark:flex" src="/atoptima_white_v2.png" />
    </a>
  </header>

  <main class="flex flex-1 flex-col items-center justify-center px-6 py-8">
    <div class="w-full max-w-md text-center">
      <ng-content></ng-content>
    </div>
  </main>

  <footer class="flex shrink-0 justify-center px-8 py-4">
    <a
      href="mailto:support@atoptima.com"
      class="text-text-tertiary hover:text-text-secondary flex items-center gap-1.5 text-xs transition-colors">
      <i class="ph-bold ph-envelope"></i>
      support&#64;atoptima.com
    </a>
  </footer>
</div>
